module.exports = __webpack_public_path__ + "static/media/matilde-hat-sri-lanka-sad.a0f07632.png";